// extracted by mini-css-extract-plugin
export default {"csContainer":"MobileMessagingServices_csContainer__iqP8v","loadingContainer":"MobileMessagingServices_loadingContainer__+kXS3","errorText":"MobileMessagingServices_errorText__xIjXo"};